// extracted by mini-css-extract-plugin
export var wrapper = "Header-module--wrapper--1OVW6";
export var content = "Header-module--content--1HKN4";